import { render, staticRenderFns } from "./HomeNewsListItem.vue?vue&type=template&id=5e5db868&scoped=true"
import script from "./HomeNewsListItem.vue?vue&type=script&lang=js"
export * from "./HomeNewsListItem.vue?vue&type=script&lang=js"
import style0 from "./HomeNewsListItem.vue?vue&type=style&index=0&id=5e5db868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5db868",
  null
  
)

export default component.exports